/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProjectDomain } from './ProjectDomain';
import {
    ProjectDomainFromJSON,
    ProjectDomainFromJSONTyped,
    ProjectDomainToJSON,
    ProjectDomainToJSONTyped,
} from './ProjectDomain';
import type { ProjectCentre } from './ProjectCentre';
import {
    ProjectCentreFromJSON,
    ProjectCentreFromJSONTyped,
    ProjectCentreToJSON,
    ProjectCentreToJSONTyped,
} from './ProjectCentre';

/**
 * 
 * @export
 * @interface ProjectCentreWithDomains
 */
export interface ProjectCentreWithDomains {
    /**
     * 
     * @type {ProjectCentre}
     * @memberof ProjectCentreWithDomains
     */
    projectCentre?: ProjectCentre;
    /**
     * 
     * @type {Array<ProjectDomain>}
     * @memberof ProjectCentreWithDomains
     */
    domains?: Array<ProjectDomain>;
}

/**
 * Check if a given object implements the ProjectCentreWithDomains interface.
 */
export function instanceOfProjectCentreWithDomains(value: object): value is ProjectCentreWithDomains {
    return true;
}

export function ProjectCentreWithDomainsFromJSON(json: any): ProjectCentreWithDomains {
    return ProjectCentreWithDomainsFromJSONTyped(json, false);
}

export function ProjectCentreWithDomainsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectCentreWithDomains {
    if (json == null) {
        return json;
    }
    return {
        
        'projectCentre': json['projectCentre'] == null ? undefined : ProjectCentreFromJSON(json['projectCentre']),
        'domains': json['domains'] == null ? undefined : ((json['domains'] as Array<any>).map(ProjectDomainFromJSON)),
    };
}

export function ProjectCentreWithDomainsToJSON(json: any): ProjectCentreWithDomains {
    return ProjectCentreWithDomainsToJSONTyped(json, false);
}

export function ProjectCentreWithDomainsToJSONTyped(value?: ProjectCentreWithDomains | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'projectCentre': ProjectCentreToJSON(value['projectCentre']),
        'domains': value['domains'] == null ? undefined : ((value['domains'] as Array<any>).map(ProjectDomainToJSON)),
    };
}

